/* unplugin-vue-components disabled */import script from "./PendingOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingOrder.vue?vue&type=script&setup=true&lang=js"

import "./PendingOrder.vue?vue&type=style&index=0&id=4a6e02c2&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a6e02c2"]])

export default __exports__